import { render, staticRenderFns } from "./VeryfyTotp.vue?vue&type=template&id=0e085806"
import script from "./VeryfyTotp.vue?vue&type=script&lang=js"
export * from "./VeryfyTotp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports